import * as React from 'react';
import PropTypes from 'prop-types';

export const SendMoney = ({ width, height, ...props }) => (
  <svg
    data-icon='send-money'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M6 19.75c-1.733-.45-3.167-1.383-4.3-2.8C.567 15.533 0 13.883 0 12s.567-3.533 1.7-4.95C2.833 5.633 4.267 4.7 6 4.25v2.1A5.742 5.742 0 0 0 3.112 8.5C2.371 9.533 2 10.7 2 12c0 1.3.37 2.467 1.112 3.5A5.742 5.742 0 0 0 6 17.65v2.1Zm8 .25c-2.217 0-4.104-.78-5.662-2.337C6.779 16.104 6 14.217 6 12s.78-4.104 2.338-5.662C9.896 4.779 11.783 4 14 4c1.1 0 2.133.208 3.1.625a8.111 8.111 0 0 1 2.55 1.725l-1.4 1.4a5.997 5.997 0 0 0-1.913-1.287A5.91 5.91 0 0 0 14 6c-1.667 0-3.083.583-4.25 1.75C8.583 8.917 8 10.333 8 12c0 1.667.583 3.083 1.75 4.25C10.917 17.417 12.333 18 14 18a5.91 5.91 0 0 0 2.337-.462 5.997 5.997 0 0 0 1.913-1.288l1.4 1.4a8.112 8.112 0 0 1-2.55 1.725c-.967.417-2 .625-3.1.625Zm6-4-1.4-1.4 1.6-1.6H13v-2h7.2l-1.6-1.6L20 8l4 4-4 4Z'
    />
  </svg>
);

SendMoney.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SendMoney.defaultProps = {
  width: 24,
  height: 24,
};
